import { Component, input, InputSignal } from '@angular/core';

import { WidgetListBlockSection } from '@core/cms/landing.cms';
import { CmsBtn } from '@shared/ui/cms-btn/cms-btn';
import { CmsImage } from '@shared/ui/cms-image/cms-image';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';

/**
 * Renders a `ComponentSectionWidgetListBlock`: a two-column layout pairing an image with a list of
 * labelled items, title/body content and an optional CTA. Column order and widths are driven by the
 * CMS layout flags. The optional search-autocomplete is out of scope for this baseline.
 */
@Component({
    selector: 'cms-widget-list-block',
    imports: [CmsBtn, CmsImage, TrustHtmlPipe],
    templateUrl: './widget-list-block.html',
    styleUrl: './widget-list-block.scss',
})
export class CmsWidgetListBlock {
    public readonly section: InputSignal<WidgetListBlockSection> =
        input.required<WidgetListBlockSection>();
}
